import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const SaintPierreEtMiquelonReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_SUMMARY.id,
        label: 'Summary',
      },
      {
        value: ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default SaintPierreEtMiquelonReport;

SaintPierreEtMiquelonReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
